import { h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import LeaderboardOverview from './LeaderboardOverview'
import Tabs from '../Tabs'

interface Props {
  isGuest: boolean
  period: string
  loggedInUserId: string|null
}

const Leaderboard = ({ isGuest, period, loggedInUserId }: Props) => {
  const tabs = ['thisWeek', 'allTime']
  const activeTab = period === 'thisWeek' ? 0 : 1
  const tabTitles = tabs.map(tab => {
    return <Phrase key={tab} p={`leaderboard.points.${tab}`} />
  })
  return (
    <div className='leaderboard-overview-container'>
      <div className='leaderboard-header-container'>
        <div className='leaderboard-title-container'>
          <h1 className='leaderboard-overview-title'> <Phrase p='leaderboard.page.title' /> </h1>
          <div className='leaderboard-overview-subtitle'> <Phrase p='leaderboard.page.subtitle' /> </div>
        </div>
        <div className='leaderboard-time-period-container' />
      </div>
      <Tabs titles={tabTitles} activeTab={activeTab} portalIntoClassName='.leaderboard-time-period-container'>
        {tabs.map(tab => <LeaderboardOverview
          key={tab}
          tabTitle={tab}
          period={tab}
          isGuest={isGuest}
          loggedInUserId={loggedInUserId}
                         />)}
      </Tabs>
    </div>
  )
}

export default Leaderboard
